module.exports = __webpack_public_path__ + "img/Character_Zhongli_Thumb.accf574c.png";